import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/dashboard";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/dashboard")(withAlternates(routeOptions, "/dashboard"));
